import { Action, Mutation } from "../types";

export default {
  [Action.ADDMESSAGE]({ commit }, listMessages) {
    return new Promise(resolve => {
      //console.log(listMessages);
      commit(`${[Mutation.ADDMESSAGE]}`, listMessages);
      resolve();
    });
  }
};
